import type { SelfTestOutcome } from '../types/selfTest'

/**
 * Must exceed the API's own global run deadline (45s), otherwise axios aborts
 * client-side moments before the server would have answered — and every run
 * looks like a timeout.
 */
export const SELF_TEST_TIMEOUT_MS = 60_000

/** Latency at or above this is amber; 3x is red. Mirrors SELF_TEST_SLOW_MS on the API. */
export const SELF_TEST_SLOW_MS = 2_000

export const SELF_TEST_OUTCOME_LABELS: Record<SelfTestOutcome, string> = {
  pass: 'Pass',
  fail: 'Fail',
  'not-covered': 'Not covered',
}

/**
 * Not-covered is grey, deliberately not amber: amber reads as "degraded",
 * whereas not-covered means "no signal at all". Conflating the two is how a
 * status board stops being trusted. Amber belongs to the latency column.
 */
export const SELF_TEST_OUTCOME_CLASSES: Record<SelfTestOutcome, string> = {
  pass: 'bg-green-100 text-green-800',
  fail: 'bg-red-100 text-red-800',
  'not-covered': 'bg-gray-100 text-gray-600',
}

/**
 * Pass, then Fail, then Not covered. Sorting by Outcome descending puts the
 * failures on top when you want them; the default ascending order leads with
 * the endpoints that are working, which is what a post-deploy check is
 * confirming most of the time.
 */
export const SELF_TEST_OUTCOME_ORDER: Record<SelfTestOutcome, number> = {
  pass: 0,
  fail: 1,
  'not-covered': 2,
}
